function assertAddress(value) {
  if (!value.startsWith("0x"))
    throw Error(`Unexpected value ${JSON.stringify(value)} is not an address`);
}

export { assertAddress };
